import { createSelector } from 'reselect';
import { SECTION_ACCESS_TYPES } from '../utils/consts';

export const getNavigationState = state => state.navigation;

export const getNavigationSections = createSelector([getNavigationState], navigationState => navigationState.sections);

export const getElementAccessType = elementName =>
    createSelector([getNavigationSections], navigationSections => {
        const element = navigationSections
            .flatMap(section => section.elements)
            .find(({ name }) => name === elementName);
        const sections = element?.sections || [];
        return sections.some(({ access_type: accessType }) => accessType === SECTION_ACCESS_TYPES.EDIT)
            ? SECTION_ACCESS_TYPES.EDIT
            : SECTION_ACCESS_TYPES.VIEW;
    });
